import { render } from "./USTermsAndConditionPage.vue?vue&type=template&id=57041b4a&scoped=true&ts=true"
import script from "./USTermsAndConditionPage.vue?vue&type=script&lang=ts"
export * from "./USTermsAndConditionPage.vue?vue&type=script&lang=ts"

import "./USTermsAndConditionPage.vue?vue&type=style&index=0&id=57041b4a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57041b4a"]])

export default __exports__